(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8614],{

/***/ 60376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54235);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


/**
 * @ignore - internal component.
 */


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft'));

/***/ }),

/***/ 79476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54235);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


/**
 * @ignore - internal component.
 */


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight'));

/***/ }),

/***/ 64529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Mk": function() { return /* reexport */ ElearningDemoBooking; },
  "ll": function() { return /* reexport */ ElearningDemoFree; },
  "iW": function() { return /* reexport */ ElearningHomeCount; },
  "F_": function() { return /* reexport */ ElearningHomeHero; },
  "nB": function() { return /* reexport */ ElearningHomeHero2; },
  "t2": function() { return /* reexport */ ElearningHomeIntro; },
  "uu": function() { return /* reexport */ ElearningHomeOnlineTest; },
  "HM": function() { return /* reexport */ ElearningHomeStats; },
  "FL": function() { return /* reexport */ ElearningHomeSteps; },
  "oB": function() { return /* reexport */ ElearningTechnologySuccess; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./_modules/elearning/home/hero.module.scss
var hero_module = __webpack_require__(79590);
var hero_module_default = /*#__PURE__*/__webpack_require__.n(hero_module);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/elearning/home/hero.jsx








var ElearningHomeHero = function ElearningHomeHero() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (hero_module_default()).section_hero,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: {
          xs: 3,
          sm: 3,
          md: 6
        },
        alignItems: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 6,
          md: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (hero_module_default()).heading_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
              className: (hero_module_default()).heading,
              children: ["Hit Your Target", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "mark color-orange",
                children: "IELTS Scores"
              }), " in a Single Sitting"]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (hero_module_default()).sub_text,
              children: "Our highly-experienced IELTS trainers provide one-to-one guidance to each student, equipping you with the skills, strategies and resources you need to meet and surpass your target scores with confidence."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (hero_module_default()).btn_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "/elearning/ielts",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "btn btn-secondary btn-xl",
                  children: "Enrol Now"
                })
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 6,
          md: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (hero_module_default()).hero_image_wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              layout: "responsive",
              width: 560,
              height: 490,
              blurDataURL: (0,helpers/* getAssets */.Vh)("assets/images/study/country_placeholder.webp"),
              placeholder: "blur",
              src: (0,helpers/* getAssets */.Vh)("/assets/images/elearning/hero-image.webp"),
              alt: "hero image"
            })
          })
        })]
      })
    })
  });
};
/* harmony default export */ var hero = ((/* unused pure expression or super */ null && (ElearningHomeHero)));
// EXTERNAL MODULE: ./_modules/elearning/home/hero2.module.scss
var hero2_module = __webpack_require__(61256);
var hero2_module_default = /*#__PURE__*/__webpack_require__.n(hero2_module);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
;// CONCATENATED MODULE: ./_modules/elearning/home/hero2.jsx








var ElearningHomeHero2 = function ElearningHomeHero2() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (hero2_module_default()).section_hero,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: {
          xs: 3,
          sm: 3,
          md: 6
        },
        alignItems: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 6,
          md: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (hero2_module_default()).heading_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
              className: (hero2_module_default()).heading,
              children: ["Make your test scores skyrocket with", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "mark",
                children: "Unisearch"
              }), " Live"]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (hero2_module_default()).sub_text,
              children: "IELTS is an English language exam that is required to be taken by international candidates considering studying or working in a country where English is the main language of communication."
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (hero2_module_default()).btn_wrapper,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "#",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "btn btn-secondary btn-xl ".concat((hero2_module_default()).action_btn),
                  children: "Explore Courses"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "#",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "btn btn-grey-border btn-bg ".concat((hero2_module_default()).action_btn),
                  children: "Book for Demo"
                })
              })]
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 6,
          md: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (hero2_module_default()).hero_image_wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
              src: (0,helpers/* getAssets */.Vh)("assets/images/elearning/home/hero-illustration.svg")
            })
          })
        })]
      })
    })
  });
};
/* harmony default export */ var hero2 = ((/* unused pure expression or super */ null && (ElearningHomeHero2)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./_modules/elearning/home/count.module.scss
var count_module = __webpack_require__(93491);
var count_module_default = /*#__PURE__*/__webpack_require__.n(count_module);
;// CONCATENATED MODULE: ./_modules/elearning/home/count.jsx








var ElearningHomeCount = function ElearningHomeCount() {
  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      focus = _React$useState2[0],
      setFocus = _React$useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (count_module_default()).wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
          className: (count_module_default()).heading,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "color-orange",
            children: "Impact"
          }), " That Counts"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (count_module_default()).count_wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (count_module_default()).count_number,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(build/* default */.ZP, {
                    start: focus ? 0 : null,
                    end: 5000,
                    duration: 2,
                    redraw: true,
                    children: function children(_ref) {
                      var countUpRef = _ref.countUpRef;
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          ref: countUpRef
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)((visibility_sensor_default()), {
                          onChange: function onChange(isVisible) {
                            if (isVisible) {
                              setFocus(true);
                            }
                          },
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: "+"
                          })
                        })]
                      });
                    }
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (count_module_default()).count_text,
                children: "Students benefited"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (count_module_default()).count_number,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(build/* default */.ZP, {
                    start: focus ? 0 : null,
                    end: 200,
                    duration: 2,
                    redraw: true,
                    children: function children(_ref2) {
                      var countUpRef = _ref2.countUpRef;
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          ref: countUpRef
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)((visibility_sensor_default()), {
                          onChange: function onChange(isVisible) {
                            if (isVisible) {
                              setFocus(true);
                            }
                          },
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                              children: "K"
                            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                              children: "+"
                            })]
                          })
                        })]
                      });
                    }
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (count_module_default()).count_text,
                children: "Live training delivered"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (count_module_default()).count_number,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(build/* default */.ZP, {
                    start: focus ? 0 : null,
                    end: 50,
                    duration: 2,
                    redraw: true,
                    children: function children(_ref3) {
                      var countUpRef = _ref3.countUpRef;
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          ref: countUpRef
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)((visibility_sensor_default()), {
                          onChange: function onChange(isVisible) {
                            if (isVisible) {
                              setFocus(true);
                            }
                          },
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: "+"
                          })
                        })]
                      });
                    }
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (count_module_default()).count_text,
                children: "Educators"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (count_module_default()).count_number,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(build/* default */.ZP, {
                    start: focus ? 0 : null,
                    end: 1000,
                    duration: 2,
                    redraw: true,
                    children: function children(_ref4) {
                      var countUpRef = _ref4.countUpRef;
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          ref: countUpRef
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)((visibility_sensor_default()), {
                          onChange: function onChange(isVisible) {
                            if (isVisible) {
                              setFocus(true);
                            }
                          },
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: "+"
                          })
                        })]
                      });
                    }
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (count_module_default()).count_text,
                children: "Free Videos/Ebooks"
              })]
            })]
          })
        })]
      })
    })
  });
};
/* harmony default export */ var count = ((/* unused pure expression or super */ null && (ElearningHomeCount)));
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./_modules/study/common/play_btn_with_ripple/index.jsx
var play_btn_with_ripple = __webpack_require__(42422);
// EXTERNAL MODULE: ./_modules/elearning/home/intro.module.scss
var intro_module = __webpack_require__(76593);
var intro_module_default = /*#__PURE__*/__webpack_require__.n(intro_module);
;// CONCATENATED MODULE: ./_modules/elearning/home/intro.jsx




var ModalVideo = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1239).then(__webpack_require__.bind(__webpack_require__, 61239));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61239)];
    }
  }
});






var ElearningHomeIntro = function ElearningHomeIntro() {
  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (intro_module_default()).section_intro,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: {
          xs: 3,
          sm: 3,
          md: 6
        },
        alignItems: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 6,
          md: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (intro_module_default()).heading_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
              className: (intro_module_default()).heading,
              children: ["Welcome to UniSearch\u2019s Complete", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "color-orange",
                children: "IELTS Training"
              }), " Course"]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (intro_module_default()).sub_text,
              children: "Standardised practice kits and guidebooks can do only so much when it comes to IELTS prep. After all, English language proficiency requirements are a crucial component of your study abroad application. You want to be sure of your success when you step into that exam room, confident of your performance even before you receive your scores."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (intro_module_default()).sub_text,
              children: "Our Complete IELTS Training course is built with all this in mind. Our experienced coaches offer individualised performance evaluation and guidance geared toward each student. We combine classroom sessions and one-to-one consulting with simulated exam practice and practical resources to get your scores where they need to be!"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (intro_module_default()).btn_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "/elearning/ielts",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "btn btn-secondary btn-bg",
                  children: "Learn More"
                })
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 6,
          md: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (intro_module_default()).hero_image_wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              layout: "responsive",
              width: 561,
              height: 647,
              blurDataURL: (0,helpers/* getAssets */.Vh)("assets/images/study/country_placeholder.webp"),
              placeholder: "blur",
              src: (0,helpers/* getAssets */.Vh)("/assets/images/elearning/intro-video-image.webp"),
              alt: "Intro video feature"
            })
          })
        })]
      })
    })
  });
};
/* harmony default export */ var intro = ((/* unused pure expression or super */ null && (ElearningHomeIntro)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 20 modules
var makeStyles = __webpack_require__(6005);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(85050);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tabs/Tabs.js + 6 modules
var Tabs = __webpack_require__(62348);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tab/Tab.js + 1 modules
var Tab = __webpack_require__(18661);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./_modules/elearning/home/demo_booking.module.scss
var demo_booking_module = __webpack_require__(53063);
var demo_booking_module_default = /*#__PURE__*/__webpack_require__.n(demo_booking_module);
;// CONCATENATED MODULE: ./_modules/elearning/home/demo_booking.jsx


var _excluded = ["children", "value", "index"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










 // Material ui related




function TabPanel(props) {
  var children = props.children,
      value = props.value,
      index = props.index,
      other = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({
    role: "tabpanel",
    hidden: value !== index,
    id: "scrollable-auto-tabpanel-".concat(index),
    "aria-labelledby": "scrollable-auto-tab-".concat(index)
  }, other), {}, {
    children: value === index && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      p: 3,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        component: "div",
        children: children
      })
    })
  }));
}

function a11yProps(index) {
  return {
    id: "scrollable-auto-tab-".concat(index),
    "aria-controls": "scrollable-auto-tabpanel-".concat(index)
  };
}

var useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: "#fff"
    }
  };
});

var ExamDemoCourseCard = function ExamDemoCourseCard() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (demo_booking_module_default()).course_card,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (demo_booking_module_default()).course_image_wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: (0,helpers/* getAssets */.Vh)("assets/Rectangle.png"),
        alt: "Feature"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((demo_booking_module_default()).course_status, " ").concat((demo_booking_module_default()).bestseller),
      children: "Bestseller"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
      className: (demo_booking_module_default()).course_title,
      children: "GRE Quant - Overall View"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (demo_booking_module_default()).course_instructor_wrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (demo_booking_module_default()).instructor_avatar_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (demo_booking_module_default()).instructor_avatar,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: (0,helpers/* getAssets */.Vh)("assets/images/image 9.png"),
            alt: "Avatar"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (demo_booking_module_default()).instructor_name,
          children: "Kirill Eremenko"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (demo_booking_module_default()).course_review_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* MdOutlineStar */.QZE, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "4.5"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (demo_booking_module_default()).course_enrol_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiUsers */.WY8, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "1200+"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (demo_booking_module_default()).course_price,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (demo_booking_module_default()).course_price_regular,
        children: "\xA3319.00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (demo_booking_module_default()).course_price_deleted,
        children: "\xA3519.00"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      legacyBehavior: true,
      href: "#",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: "btn btn-secondary btn-full",
        children: "View More"
      })
    })]
  });
};

var ElearningDemoBooking = function ElearningDemoBooking() {
  var classes = useStyles();

  var _useState = (0,react.useState)(0),
      value = _useState[0],
      setValue = _useState[1];

  var handleChange = function handleChange(event, newValue) {
    setValue(newValue);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("sectiion", {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (demo_booking_module_default()).heading_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: (demo_booking_module_default()).heading,
          children: "Book your LIVE demo"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dictum nunc donec vulputate ut in sapien nunc, sit. Amet, viverra arcu est, imperdiet. Porta sollicitudin tempus odio gravida eget."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (demo_booking_module_default()).tab_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "uni_campuses ElearningCourseTab",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classes.root,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AppBar/* default */.Z, {
              position: "static",
              color: "default",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                value: value,
                onChange: handleChange,
                variant: "scrollable",
                scrollButtons: true,
                allowScrollButtonsMobile: true,
                "aria-label": "scrollable force tabs example",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, _objectSpread({
                  label: "All Course"
                }, a11yProps(0))), /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, _objectSpread({
                  label: "GMAT"
                }, a11yProps(1))), /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, _objectSpread({
                  label: "GRE"
                }, a11yProps(2))), /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, _objectSpread({
                  label: "IELTS"
                }, a11yProps(3))), /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, _objectSpread({
                  label: "TOEFL"
                }, a11yProps(4))), /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, _objectSpread({
                  label: "SAT"
                }, a11yProps(5))), /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, _objectSpread({
                  label: "PTE"
                }, a11yProps(5)))]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabPanel, {
              value: value,
              index: 0,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                spacing: {
                  xs: 1,
                  sm: 2,
                  md: 4
                },
                alignItems: "center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                  item: true,
                  xs: 12,
                  sm: 6,
                  md: 3,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExamDemoCourseCard, {})
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                  item: true,
                  xs: 12,
                  sm: 6,
                  md: 3,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExamDemoCourseCard, {})
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                  item: true,
                  xs: 12,
                  sm: 6,
                  md: 3,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExamDemoCourseCard, {})
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                  item: true,
                  xs: 12,
                  sm: 6,
                  md: 3,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExamDemoCourseCard, {})
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabPanel, {
              value: value,
              index: 1,
              children: "Gmat"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabPanel, {
              value: value,
              index: 2,
              children: "GRE"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabPanel, {
              value: value,
              index: 3,
              children: "IELTS"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabPanel, {
              value: value,
              index: 4,
              children: "TOEFL"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabPanel, {
              value: value,
              index: 5,
              children: "SAT"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabPanel, {
              value: value,
              index: 6,
              children: "PTE"
            })]
          })
        })
      })]
    })
  });
};
/* harmony default export */ var demo_booking = ((/* unused pure expression or super */ null && (ElearningDemoBooking)));
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(41548);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(73873);
// EXTERNAL MODULE: ./_modules/elearning/home/demo_free.module.scss
var demo_free_module = __webpack_require__(31327);
var demo_free_module_default = /*#__PURE__*/__webpack_require__.n(demo_free_module);
;// CONCATENATED MODULE: ./_modules/elearning/home/demo_free.jsx


var demo_free_excluded = ["children", "value", "index"],
    _excluded2 = ["item"];

function demo_free_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function demo_free_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? demo_free_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : demo_free_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var demo_free_ModalVideo = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1239).then(__webpack_require__.bind(__webpack_require__, 61239));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61239)];
    }
  }
});




var data = [{
  id: 1,
  title: "The complete IELTS comprehensive course of learning",
  image: (0,helpers/* getAssets */.Vh)("assets/images/elearning/home/free_demo.png")
}, {
  id: 2,
  title: "IELTS comprehensive course of learning",
  image: (0,helpers/* getAssets */.Vh)("assets/images/elearning/home/free_demo3.jpg")
}, {
  id: 3,
  title: "Complete IELTS comprehensive course of learning",
  image: (0,helpers/* getAssets */.Vh)("assets/images/elearning/home/free_demo2.png")
}, {
  id: 4,
  title: "Complete IELTS course of learning detail learning of IELTS",
  image: (0,helpers/* getAssets */.Vh)("assets/images/elearning/home/free_demo4.jpg")
}];

function NextArrow(props) {
  var className = props.className,
      style = props.style,
      onClick = props.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiChevronRight */.Tfp, {
    className: "".concat(className, " ExamFreeDemo InstructionGallerySliderNext"),
    onClick: onClick
  });
}

function PrevArrow(props) {
  var className = props.className,
      style = props.style,
      onClick = props.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiChevronLeft */.YFh, {
    className: "".concat(className, " ExamFreeDemo InstructionGallerySliderPrev"),
    onClick: onClick
  });
} // Material ui related


function demo_free_TabPanel(props) {
  var children = props.children,
      value = props.value,
      index = props.index,
      other = (0,objectWithoutProperties/* default */.Z)(props, demo_free_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", demo_free_objectSpread(demo_free_objectSpread({
    role: "tabpanel",
    hidden: value !== index,
    id: "scrollable-auto-tabpanel-".concat(index),
    "aria-labelledby": "scrollable-auto-tab-".concat(index)
  }, other), {}, {
    children: value === index && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      p: 3,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        component: "div",
        children: children
      })
    })
  }));
}

function demo_free_a11yProps(index) {
  return {
    id: "scrollable-auto-tab-".concat(index),
    "aria-controls": "scrollable-auto-tabpanel-".concat(index)
  };
}

var demo_free_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: "#fff"
    }
  };
});
var ElearningDemoFree = function ElearningDemoFree() {
  var _useState = (0,react.useState)(false),
      isOpenVideo = _useState[0],
      setOpenVideo = _useState[1];

  var settings = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    centerPadding: "60px",
    nextArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(NextArrow, {}),
    prevArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(PrevArrow, {}),
    responsive: [{
      breakpoint: 900,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 600,
      settings: {
        arrows: true,
        dots: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  };
  var classes = demo_free_useStyles();

  var _useState2 = (0,react.useState)(0),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleChange = function handleChange(event, newValue) {
    setValue(newValue);
  };

  var ExamFreeDemoCard = function ExamFreeDemoCard(_ref) {
    var item = _ref.item,
        props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded2);

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (demo_free_module_default()).exam_free_demo_card,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (demo_free_module_default()).card_image_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: item === null || item === void 0 ? void 0 : item.image,
          alt: "free demo"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(play_btn_with_ripple/* default */.Z, {
          medium: true,
          onClick: function onClick() {
            return setOpenVideo(true);
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (demo_free_module_default()).demo_card_body,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          legacyBehavior: true,
          href: "#",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: (demo_free_module_default()).demo_link,
            children: item === null || item === void 0 ? void 0 : item.title
          })
        })
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (demo_free_module_default()).tab_wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "ExamFreeDemoTabs",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classes.root,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AppBar/* default */.Z, {
                position: "static",
                color: "default",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                  value: value,
                  onChange: handleChange,
                  variant: "scrollable",
                  scrollButtons: true,
                  allowScrollButtonsMobile: true,
                  "aria-label": "scrollable auto tabs example",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, demo_free_objectSpread({
                    label: "IELTS"
                  }, demo_free_a11yProps(0))), /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, demo_free_objectSpread({
                    label: "PTE"
                  }, demo_free_a11yProps(1))), /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, demo_free_objectSpread({
                    label: "GMAT"
                  }, demo_free_a11yProps(2))), /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, demo_free_objectSpread({
                    label: "GRE"
                  }, demo_free_a11yProps(3))), /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, demo_free_objectSpread({
                    label: "TOEFL"
                  }, demo_free_a11yProps(4)))]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(demo_free_TabPanel, {
                value: value,
                index: 0,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                  container: true,
                  spacing: 4,
                  alignItems: "center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 12,
                    md: 4,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: (demo_free_module_default()).heading_wrapper,
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                        className: (demo_free_module_default()).heading,
                        children: "Score a 8+ band score on the International Standardised Test for English Proficiency"
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: (demo_free_module_default()).sub_text,
                        children: "Ipsum quis pulvinar vitae bibendum gravida maecenas fusce etiam. Scelerisque sit nunc, praesent blandit risus. Tortor vulputate nibh."
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: (demo_free_module_default()).btn_wrapper,
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                        legacyBehavior: true,
                        href: "#",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                          className: "btn btn-secondary btn-bg",
                          children: "Join for FREE Demo"
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                        legacyBehavior: true,
                        href: "#",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                          className: "btn btn-grey-border btn-bg",
                          children: "More"
                        })
                      })]
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 12,
                    md: 8,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "instructioin-video-slider exam-free-demo-slider",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib["default"], demo_free_objectSpread(demo_free_objectSpread({}, settings), {}, {
                        children: data.map(function (item) {
                          return /*#__PURE__*/(0,jsx_runtime.jsx)(ExamFreeDemoCard, {
                            item: item
                          }, item.id);
                        })
                      }))
                    })
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(demo_free_TabPanel, {
                value: value,
                index: 1,
                children: "PTE"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(demo_free_TabPanel, {
                value: value,
                index: 2,
                children: "GMAT"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(demo_free_TabPanel, {
                value: value,
                index: 3,
                children: "GRE"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(demo_free_TabPanel, {
                value: value,
                index: 4,
                children: "TOEFL"
              })]
            })
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(demo_free_ModalVideo, {
      channel: "custom",
      autoplay: true,
      isOpen: isOpenVideo,
      url: "https://d2ogu7kfbtzzv3.cloudfront.net/files/UniSearch_Finale-1634995602483.mp4",
      onClose: function onClose() {
        return setOpenVideo(false);
      }
    })]
  });
};
/* harmony default export */ var demo_free = ((/* unused pure expression or super */ null && (ElearningDemoFree)));
// EXTERNAL MODULE: ./_modules/elearning/home/technology_success.module.scss
var technology_success_module = __webpack_require__(76130);
var technology_success_module_default = /*#__PURE__*/__webpack_require__.n(technology_success_module);
;// CONCATENATED MODULE: ./_modules/elearning/home/technology_success.jsx


function technology_success_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function technology_success_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? technology_success_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : technology_success_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var ElearningTechnologySuccess = function ElearningTechnologySuccess() {
  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 900,
      settings: {
        arrows: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (technology_success_module_default()).section_technology,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (technology_success_module_default()).heading_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
          className: (technology_success_module_default()).heading,
          children: ["Technology Built for", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "color-orange",
            children: "Your Success"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dictum nunc donec vulputate ut in sapien nunc, sit. Amet, viverra arcu est, imperdiet. Porta sollicitudin tempus odio gravida eget."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "elearning_exam_success_slider",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(lib["default"], technology_success_objectSpread(technology_success_objectSpread({}, settings), {}, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (technology_success_module_default()).success_slider_wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
              container: true,
              spacing: {
                xs: 2,
                sm: 2,
                md: 4
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 12,
                md: 6,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (technology_success_module_default()).image_wrapper,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                    src: (0,helpers/* getAssets */.Vh)("assets/images/elearning/home/laptop-mockup.png"),
                    alt: "laptop-mockup"
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 12,
                md: 6,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (technology_success_module_default()).description_wrapper,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    className: (technology_success_module_default()).description_heading,
                    children: "Secure and Robust"
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (technology_success_module_default()).description,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac massa enim id tincidunt eget vitae. Consequat egestas amet, elit eu. Egestas placerat laoreet varius risus, mauris vitae dui, amet. Nulla quam porttitor non consequat, pulvinar."
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: "Eu odio nam convallis velit enim volutpat. Ipsum quis pulvinar vitae bibendum gravida maecenas fusce etiam. Scelerisque sit nunc, praesent blandit risus. Tortor vulputate nibh ipsum amet, nam turpis volutpat facilisis ornare. Orci."
                    })]
                  })]
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (technology_success_module_default()).success_slider_wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
              container: true,
              spacing: {
                xs: 2,
                sm: 2,
                md: 4
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 12,
                md: 6,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (technology_success_module_default()).image_wrapper,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                    src: (0,helpers/* getAssets */.Vh)("assets/images/elearning/home/laptop-mockup.png"),
                    alt: "laptop-mockup"
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 12,
                md: 6,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (technology_success_module_default()).description_wrapper,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    className: (technology_success_module_default()).description_heading,
                    children: "Secure and Robust"
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (technology_success_module_default()).description,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac massa enim id tincidunt eget vitae. Consequat egestas amet, elit eu. Egestas placerat laoreet varius risus, mauris vitae dui, amet. Nulla quam porttitor non consequat, pulvinar."
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: "Eu odio nam convallis velit enim volutpat. Ipsum quis pulvinar vitae bibendum gravida maecenas fusce etiam. Scelerisque sit nunc, praesent blandit risus. Tortor vulputate nibh ipsum amet, nam turpis volutpat facilisis ornare. Orci."
                    })]
                  })]
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (technology_success_module_default()).success_slider_wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
              container: true,
              spacing: {
                xs: 2,
                sm: 2,
                md: 4
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 12,
                md: 6,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (technology_success_module_default()).image_wrapper,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                    src: (0,helpers/* getAssets */.Vh)("assets/images/elearning/home/laptop-mockup.png"),
                    alt: "laptop-mockup"
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 12,
                md: 6,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (technology_success_module_default()).description_wrapper,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    className: (technology_success_module_default()).description_heading,
                    children: "Secure and Robust"
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (technology_success_module_default()).description,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac massa enim id tincidunt eget vitae. Consequat egestas amet, elit eu. Egestas placerat laoreet varius risus, mauris vitae dui, amet. Nulla quam porttitor non consequat, pulvinar."
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: "Eu odio nam convallis velit enim volutpat. Ipsum quis pulvinar vitae bibendum gravida maecenas fusce etiam. Scelerisque sit nunc, praesent blandit risus. Tortor vulputate nibh ipsum amet, nam turpis volutpat facilisis ornare. Orci."
                    })]
                  })]
                })
              })]
            })
          })]
        }))
      })]
    })
  });
};
/* harmony default export */ var technology_success = ((/* unused pure expression or super */ null && (ElearningTechnologySuccess)));
// EXTERNAL MODULE: ./_modules/elearning/home/online_test.module.scss
var online_test_module = __webpack_require__(53186);
var online_test_module_default = /*#__PURE__*/__webpack_require__.n(online_test_module);
;// CONCATENATED MODULE: ./_modules/elearning/home/online_test.jsx









var ElearningHomeOnlineTest = function ElearningHomeOnlineTest() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (online_test_module_default()).section_onlinetest,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
        className: (online_test_module_default()).title,
        children: ["Why Enrol for UniSearch\u2019s", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Complete", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "color-orange",
          children: "IELTS Training Course?"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: {
          xs: 3,
          sm: 3,
          md: 4
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 6,
          md: 4,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (online_test_module_default()).test_card,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              width: 56,
              height: 56,
              src: (0,helpers/* getAssets */.Vh)("/assets/images/elearning/ielts-paper.webp"),
              alt: "icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (online_test_module_default()).test_title,
              children: "Practice Real IELTS Papers"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (online_test_module_default()).test_desc,
              children: "Learn what to expect with IELTS past papers and practice tests simulating the real deal, including Listening section audio recordings and one-to-one Speaking sessions"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 6,
          md: 4,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (online_test_module_default()).test_card,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              width: 56,
              height: 56,
              src: (0,helpers/* getAssets */.Vh)("/assets/images/elearning/community-input.webp"),
              alt: "icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (online_test_module_default()).test_title,
              children: "All-Inclusive Community Input"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (online_test_module_default()).test_desc,
              children: "This course is built with the insight and knowledge of our experienced and dedicated community of IELTS trainers, counselors, past examiners and exam takers"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 6,
          md: 4,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (online_test_module_default()).test_card,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              width: 56,
              height: 56,
              src: (0,helpers/* getAssets */.Vh)("/assets/images/elearning/analytics-tool.webp"),
              alt: "icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (online_test_module_default()).test_title,
              children: "Comprehensive Analytics Tool"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (online_test_module_default()).test_desc,
              children: "Set target score goals and get real-time feedback of your performance to chart your progress and pinpoint areas to improve"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 6,
          md: 4,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (online_test_module_default()).test_card,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              width: 56,
              height: 56,
              src: (0,helpers/* getAssets */.Vh)("/assets/images/elearning/sample-answers.webp"),
              alt: "icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (online_test_module_default()).test_title,
              children: "View Practice Scores and Sample Answers with Explanations"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (online_test_module_default()).test_desc,
              children: "Check your current performance and progress through scored practice tests, with sample answers and evaluations to help you improve"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 6,
          md: 4,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (online_test_module_default()).test_card,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              width: 56,
              height: 56,
              src: (0,helpers/* getAssets */.Vh)("/assets/images/elearning/support.webp"),
              alt: "icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (online_test_module_default()).test_title,
              children: "All-Around Support to Boost Your Score"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (online_test_module_default()).test_desc,
              children: "Our expert trainers provide individualised feedback and support to each student based on their performance, strengths and weaknesses"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 6,
          md: 4,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (online_test_module_default()).test_card,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              width: 56,
              height: 56,
              src: (0,helpers/* getAssets */.Vh)("/assets/images/elearning/boost-scores.webp"),
              alt: "icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (online_test_module_default()).test_title,
              children: "Boost Your IELTS Band Scores"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (online_test_module_default()).test_desc,
              children: "Finetune your scores for individual IELTS sections with targeted practice, guidance and resources to improve your performance"
            })]
          })
        })]
      })]
    })
  });
};
/* harmony default export */ var online_test = ((/* unused pure expression or super */ null && (ElearningHomeOnlineTest)));
// EXTERNAL MODULE: ./_modules/elearning/home/steps.module.scss
var steps_module = __webpack_require__(22782);
var steps_module_default = /*#__PURE__*/__webpack_require__.n(steps_module);
;// CONCATENATED MODULE: ./_modules/elearning/home/steps.jsx









var ElearningHomeSteps = function ElearningHomeSteps() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (steps_module_default()).section_steps,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
        className: (steps_module_default()).title,
        children: ["How to ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "color-orange",
          children: "Enrol"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (steps_module_default()).steps_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (steps_module_default()).line
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              className: (steps_module_default()).step_icon,
              width: 100,
              height: 100,
              src: (0,helpers/* getAssets */.Vh)("/assets/images/elearning/training-page.webp"),
              alt: "icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (steps_module_default()).step_num,
              children: "Step 1"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (steps_module_default()).step_text,
              children: "Go to the official UniSearch Complete IELTS Training page"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              className: (steps_module_default()).step_icon,
              width: 100,
              height: 100,
              src: (0,helpers/* getAssets */.Vh)("/assets/images/elearning/application-form.webp"),
              alt: "icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (steps_module_default()).step_num,
              children: "Step 2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (steps_module_default()).step_text,
              children: "Complete the online application form"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              className: (steps_module_default()).step_icon,
              width: 100,
              height: 100,
              src: (0,helpers/* getAssets */.Vh)("/assets/images/elearning/registration-fee.webp"),
              alt: "icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (steps_module_default()).step_num,
              children: "Step 3"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (steps_module_default()).step_text,
              children: "Pay the registration fee"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              className: (steps_module_default()).step_icon,
              width: 100,
              height: 100,
              src: (0,helpers/* getAssets */.Vh)("/assets/images/elearning/acknowledgement.webp"),
              alt: "icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (steps_module_default()).step_num,
              children: "Step 4"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (steps_module_default()).step_text,
              children: "Get instant seat booking and acknowledgement"
            })]
          })]
        })]
      })]
    })
  });
};
/* harmony default export */ var steps = ((/* unused pure expression or super */ null && (ElearningHomeSteps)));
// EXTERNAL MODULE: ./_modules/elearning/home/stats.module.scss
var stats_module = __webpack_require__(63472);
var stats_module_default = /*#__PURE__*/__webpack_require__.n(stats_module);
;// CONCATENATED MODULE: ./_modules/elearning/home/stats.jsx








var ElearningHomeStats = function ElearningHomeStats() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (stats_module_default()).section_stats,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: {
          xs: 3,
          sm: 3,
          md: 6
        },
        alignItems: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 12,
          md: 6,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (stats_module_default()).heading_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (stats_module_default()).sub_text,
              children: "Your Dream University is Not a Dream Anymore"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: (stats_module_default()).heading,
              children: "5000+ Students have made it to their dream universities with us"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: (stats_module_default()).sub_heading,
              children: "Now it\u2019s your turn!"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (stats_module_default()).btn_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              legacyBehavior: true,
              href: "#",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "btn btn-secondary btn-xl ".concat((stats_module_default()).link_btn),
                children: "Book Your 30 Mins Call Now"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              legacyBehavior: true,
              href: "#",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "btn btn-grey-border btn-bg ".concat((stats_module_default()).link_btn),
                children: "Explore More"
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          sm: 12,
          md: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            spacing: {
              xs: 2,
              sm: 3,
              md: 3
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              sm: 6,
              md: 6,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "".concat((stats_module_default()).count_card, " ").concat((stats_module_default()).count_card_1),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                  src: (0,helpers/* getAssets */.Vh)("assets/images/elearning/home/network.svg")
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (stats_module_default()).count_num,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: "300"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: "+"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (stats_module_default()).count_text,
                  children: "Offers from Ivy-League Universities"
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              sm: 6,
              md: 6,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "".concat((stats_module_default()).count_card),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                  src: (0,helpers/* getAssets */.Vh)("assets/images/elearning/home/student-with-hat.svg")
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (stats_module_default()).count_num,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: "1000"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: "+"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (stats_module_default()).count_text,
                  children: "Offers from top global universities"
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              sm: 6,
              md: 6,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "".concat((stats_module_default()).count_card),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                  src: (0,helpers/* getAssets */.Vh)("assets/images/elearning/home/student-group.svg")
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (stats_module_default()).count_num,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: "50"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: "+"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (stats_module_default()).count_text,
                  children: "Internationally trained counsellors"
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              sm: 6,
              md: 6,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "".concat((stats_module_default()).count_card, " ").concat((stats_module_default()).count_card_4),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                  src: (0,helpers/* getAssets */.Vh)("assets/images/elearning/home/video-call.svg")
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (stats_module_default()).count_num,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: "2000"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: "+"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (stats_module_default()).count_text,
                  children: "Mentors"
                })]
              })
            })]
          })
        })]
      })
    })
  });
};
/* harmony default export */ var stats = ((/* unused pure expression or super */ null && (ElearningHomeStats)));
;// CONCATENATED MODULE: ./_modules/elearning/home/index.js











/***/ }),

/***/ 42422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ PlayButtonWithRipple; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30890);
/* harmony import */ var _play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["colorOrange", "medium", "ripple", "small"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var PlayButtonWithRipple = function PlayButtonWithRipple(_ref) {
  var colorOrange = _ref.colorOrange,
      medium = _ref.medium,
      _ref$ripple = _ref.ripple,
      ripple = _ref$ripple === void 0 ? true : _ref$ripple,
      small = _ref.small,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", _objectSpread(_objectSpread({
    className: "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().play_btn), " ").concat(colorOrange ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().orange)) : "", " ").concat(medium ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().medium)) : "", " ").concat(small ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().small)) : "")
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow_right)
    }), ripple && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ripple_effect)
    })]
  }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PlayButtonWithRipple);

/***/ }),

/***/ 93491:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"count_wrapper__9xPf6","heading":"count_heading__kQ9Y3","count_wrapper":"count_count_wrapper__TxkCT","count_number":"count_count_number___7QzV"};

/***/ }),

/***/ 53063:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading_wrapper":"demo_booking_heading_wrapper__8Yosp","course_card":"demo_booking_course_card__8tPFs","course_image_wrapper":"demo_booking_course_image_wrapper__wyhYU","course_status":"demo_booking_course_status__74LmZ","bestseller":"demo_booking_bestseller__91XEx","course_title":"demo_booking_course_title__L07om","course_instructor_wrapper":"demo_booking_course_instructor_wrapper__6EeCr","instructor_avatar":"demo_booking_instructor_avatar__QrYdo","instructor_avatar_wrapper":"demo_booking_instructor_avatar_wrapper__OoMTl","instructor_name":"demo_booking_instructor_name__aP6yv","course_review_wrapper":"demo_booking_course_review_wrapper__10DjP","course_enrol_wrapper":"demo_booking_course_enrol_wrapper__fp9Xn","course_price":"demo_booking_course_price__KMBic","course_price_regular":"demo_booking_course_price_regular__TuutG","course_price_deleted":"demo_booking_course_price_deleted__RCWCf"};

/***/ }),

/***/ 31327:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab_wrapper":"demo_free_tab_wrapper__gvPEL","heading_wrapper":"demo_free_heading_wrapper__YtV_y","heading":"demo_free_heading__q0Q2H","sub_text":"demo_free_sub_text__1TH_r","btn_wrapper":"demo_free_btn_wrapper__XjWce","exam_free_demo_card":"demo_free_exam_free_demo_card__aMzJx","card_image_wrapper":"demo_free_card_image_wrapper__5wK6j","demo_card_body":"demo_free_demo_card_body__nUz8C","demo_link":"demo_free_demo_link__mJbwf"};

/***/ }),

/***/ 79590:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_hero":"hero_section_hero__5CPRb","heading_wrapper":"hero_heading_wrapper__N_M7D","heading":"hero_heading__XQy4O","sub_text":"hero_sub_text__xc5PF","btn_wrapper":"hero_btn_wrapper__DCVVC","hero_image_wrapper":"hero_hero_image_wrapper__UY7Pf"};

/***/ }),

/***/ 61256:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_hero":"hero2_section_hero__5fThi","heading_wrapper":"hero2_heading_wrapper__4lG_x","heading":"hero2_heading__PwTOL","sub_text":"hero2_sub_text__JbbWk","btn_wrapper":"hero2_btn_wrapper__l_D9X","hero_image_wrapper":"hero2_hero_image_wrapper__9sY7Y","action_btn":"hero2_action_btn__lLBDZ"};

/***/ }),

/***/ 76593:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_intro":"intro_section_intro__G5dJp","heading_wrapper":"intro_heading_wrapper__Du7Jx","heading":"intro_heading__UfNAt","sub_text":"intro_sub_text__DNTVk","btn_wrapper":"intro_btn_wrapper__wnMRP","hero_image_wrapper":"intro_hero_image_wrapper__sEnmr"};

/***/ }),

/***/ 53186:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_onlinetest":"online_test_section_onlinetest__3hUvB","title":"online_test_title__B__Xs","test_card":"online_test_test_card__hTF0H","test_icon":"online_test_test_icon__a4VEp","test_title":"online_test_test_title__fI2rd","test_desc":"online_test_test_desc__MC5Zt"};

/***/ }),

/***/ 63472:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading_wrapper":"stats_heading_wrapper__3ctaj","heading":"stats_heading__JyZ0c","sub_text":"stats_sub_text__iTQi4","sub_heading":"stats_sub_heading__9snhP","btn_wrapper":"stats_btn_wrapper__g_4un","count_card":"stats_count_card__hcY_c","count_num":"stats_count_num__vN1Ri","count_card_1":"stats_count_card_1__FgIcj","count_card_4":"stats_count_card_4__M0Ifn","link_btn":"stats_link_btn__y08cP"};

/***/ }),

/***/ 22782:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"steps_title__3JCIb","steps_wrapper":"steps_steps_wrapper__1r0Kt","line":"steps_line__TQC0V","step_icon":"steps_step_icon__MjJsF","step_num":"steps_step_num__e4n3A","step_text":"steps_step_text__Tbt88"};

/***/ }),

/***/ 76130:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading_wrapper":"technology_success_heading_wrapper__Cqb6g","heading":"technology_success_heading__dLACb","image_wrapper":"technology_success_image_wrapper__ZZBtq","description_wrapper":"technology_success_description_wrapper__Sas1e","section_technology":"technology_success_section_technology__BIDmL"};

/***/ }),

/***/ 30890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"play_btn":"play_btn_with_ripple_play_btn__yNA0_","arrow_right":"play_btn_with_ripple_arrow_right__Fmzao","ripple_effect":"play_btn_with_ripple_ripple_effect__4Jxcn","ModalRipple":"play_btn_with_ripple_ModalRipple__5yAi9","medium":"play_btn_with_ripple_medium__ClXl0","small":"play_btn_with_ripple_small__EszEQ","orange":"play_btn_with_ripple_orange__1q96e"};

/***/ })

}]);